function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadbandHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 433.259 101.014 L 116.432 101.014 C 116.413 99.905 115.509 99.016 114.401 99.016 L 101.922 99.016 C 100.813 99.016 99.909 99.905 99.891 101.014 L 96.835 101.014 C 96.817 99.905 95.913 99.016 94.804 99.016 L 82.325 99.016 C 81.217 99.016 80.313 99.905 80.294 101.014 L 69.175 101.014 C 55.74 101.029 44.853 111.917 44.838 125.352 L 44.838 125.591 C 44.799 125.589 44.763 125.58 44.724 125.58 L 44.438 125.58 C 43.315 125.58 42.404 126.491 42.404 127.615 L 42.404 151.416 C 42.404 152.54 43.315 153.451 44.438 153.451 L 44.724 153.451 C 44.763 153.451 44.799 153.442 44.838 153.439 L 44.838 376.646 C 44.853 390.081 55.74 400.968 69.175 400.983 L 433.259 400.983 C 446.694 400.968 457.581 390.081 457.596 376.646 L 457.596 125.352 C 457.581 111.917 446.694 101.03 433.259 101.014 Z M 450.271 376.646 C 450.26 386.037 442.65 393.647 433.259 393.658 L 69.175 393.658 C 59.784 393.647 52.174 386.037 52.163 376.646 L 52.163 125.352 C 52.174 115.961 59.784 108.35 69.175 108.34 L 433.259 108.34 C 442.65 108.35 450.26 115.961 450.271 125.352 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 433.259 397.727 L 69.175 397.727 C 57.538 397.714 48.107 388.283 48.093 376.646 L 48.093 125.352 C 48.107 113.714 57.538 104.283 69.175 104.27 L 433.259 104.27 C 444.896 104.283 454.327 113.714 454.341 125.352 L 454.341 376.646 C 454.327 388.283 444.896 397.714 433.259 397.727 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 433.37 380.744 L 69.064 380.744 C 66.503 380.741 64.427 378.665 64.424 376.103 L 64.424 125.894 C 64.427 123.332 66.503 121.256 69.064 121.254 L 433.37 121.254 C 435.931 121.256 438.007 123.332 438.01 125.894 L 438.01 376.103 C 438.007 378.665 435.932 380.741 433.37 380.744 Z",
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.339,
    cy: 250.563,
    r: 1.742,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 201.386 154.362 L 123.994 154.362 C 111.354 154.376 101.11 164.62 101.096 177.261 L 101.096 184.256 C 100.414 184.068 99.742 184.586 99.751 185.294 L 99.751 190.673 C 99.742 191.38 100.414 191.899 101.096 191.711 L 101.096 199.856 C 100.414 199.669 99.742 200.187 99.751 200.894 L 99.751 214.343 C 99.742 215.05 100.414 215.568 101.096 215.381 L 101.096 220.298 C 100.414 220.11 99.742 220.629 99.751 221.336 L 99.751 234.785 C 99.742 235.492 100.414 236.01 101.096 235.822 L 101.096 377.842 C 101.11 390.482 111.354 400.726 123.994 400.74 L 201.386 400.74 C 214.027 400.726 224.271 390.482 224.285 377.842 L 224.285 177.261 C 224.271 164.62 214.027 154.376 201.386 154.362 Z M 219.444 377.842 C 219.432 387.81 211.354 395.888 201.386 395.899 L 123.994 395.899 C 114.026 395.888 105.949 387.81 105.937 377.842 L 105.937 177.261 C 105.949 167.293 114.026 159.215 123.994 159.203 L 201.386 159.203 C 211.354 159.215 219.432 167.293 219.444 177.261 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 201.386 398.589 L 123.994 398.589 C 112.542 398.576 103.261 389.295 103.248 377.842 L 103.248 177.261 C 103.261 165.808 112.542 156.527 123.994 156.514 L 201.386 156.514 C 212.839 156.527 222.12 165.808 222.133 177.261 L 222.133 377.842 C 222.12 389.295 212.839 398.576 201.386 398.589 Z",
    fill: "#e6e6e6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 203.299 395.361 L 122.082 395.361 C 114.358 395.352 108.098 389.093 108.089 381.368 L 108.089 173.734 C 108.098 166.01 114.358 159.75 122.082 159.741 L 132.674 159.741 C 133.95 159.743 134.985 160.777 134.986 162.054 C 134.99 165.826 138.047 168.882 141.819 168.886 L 182.486 168.886 C 186.258 168.882 189.314 165.826 189.319 162.054 C 189.32 160.777 190.355 159.743 191.631 159.741 L 203.299 159.741 C 211.023 159.75 217.283 166.01 217.292 173.734 L 217.292 381.368 C 217.283 389.092 211.023 395.352 203.299 395.361 Z",
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.187 164.448 L 156.504 164.448 C 155.676 164.448 155.158 163.552 155.572 162.835 C 155.764 162.502 156.12 162.297 156.504 162.297 L 166.187 162.297 C 167.015 162.299 167.531 163.196 167.115 163.913 C 166.923 164.244 166.57 164.448 166.187 164.448 Z",
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.911,
    cy: 163.642,
    r: 0.538,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 173.457 215.009 L 173.569 217.512 C 186.364 216.939 201.179 218.054 216.948 220.685 L 216.948 218.147 C 201.156 215.536 186.306 214.434 173.457 215.009 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 157.547 264.029 C 157.448 264.987 157.367 265.951 157.305 266.92 C 157.173 268.827 157.107 270.748 157.107 272.685 C 157.127 309.711 181.461 342.329 216.948 352.897 L 216.948 192.457 C 184.495 202.105 161.05 230.354 157.547 264.029 Z",
    fill: "#1f306d",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.79,
    cy: 213.877,
    r: 1.65,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.275,
    cy: 278.438,
    r: 3.259,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.639,
    cy: 193.097,
    r: 2.36,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.945,
    cy: 324.461,
    r: 1.883,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.979,
    cy: 350.67,
    r: 2.039,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.257 145.353 213.233 145.353 213.233 141.329 211.074 141.329 211.074 145.353 207.048 145.353 207.048 147.513 211.074 147.513 211.074 151.537 213.233 151.537 213.233 147.513 217.257 147.513 217.257 145.353",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.022,
    cy: 258.623,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.538,
    cy: 308.162,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160.517 264.079 C 151.889 258.285 145.462 252.57 141.416 247.09 C 137.379 241.624 135.94 236.686 137.138 232.414 C 138.335 228.141 142.131 224.67 148.421 222.098 C 154.726 219.52 163.187 217.977 173.569 217.512 L 173.457 215.009 C 151.225 216.006 137.469 221.946 134.725 231.737 C 131.981 241.528 140.645 253.753 159.121 266.159 C 174.187 276.276 194.367 285.619 216.948 293.019 L 216.948 290.382 C 194.9 283.096 175.227 273.956 160.517 264.079 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160.516 266.083 C 159.497 265.398 158.507 264.713 157.547 264.029 C 157.448 264.987 157.367 265.951 157.305 266.92 C 157.899 267.335 158.504 267.749 159.121 268.163 C 174.188 278.28 194.367 287.623 216.948 295.023 L 216.948 292.386 C 194.901 285.1 175.228 275.96 160.516 266.083 Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253.825 225.733 C 243.971 222.971 234.205 220.721 224.728 218.99 L 224.728 221.536 C 233.985 223.243 243.523 225.447 253.149 228.145 C 283.795 236.735 311.527 249.253 329.232 262.489 L 330.733 260.483 C 312.789 247.068 284.757 234.402 253.825 225.733 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 327.394 272.685 C 327.362 218.814 277.203 178.992 224.728 191.174 L 224.728 354.189 C 262.734 363.036 301.811 344.453 318.934 309.389 C 319.366 308.509 319.781 307.62 320.179 306.723 C 324.952 296.011 327.41 284.412 327.395 272.685 Z",
    fill: "#1f306d",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.934,
    cy: 172.961,
    r: 0.959,
    fill: "#f2f2f2",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.814,
    cy: 178.715,
    r: 2.172,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.84,
    cy: 268.849,
    r: 3.526,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.268,
    cy: 212.532,
    r: 1.513,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.973,
    cy: 261.701,
    r: 1.513,
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.54 363.089 311.012 363.089 311.012 360.563 309.656 360.563 309.656 363.089 307.13 363.089 307.13 364.446 309.656 364.446 309.656 366.973 311.012 366.973 311.012 364.446 313.54 364.446 313.54 363.089",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.858 350.157 369.97 350.157 369.97 348.269 368.955 348.269 368.955 350.157 367.066 350.157 367.066 351.171 368.955 351.171 368.955 353.059 369.97 353.059 369.97 351.171 371.858 351.171 371.858 350.157",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.975,
    cy: 207.166,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.975,
    cy: 269.49,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.689,
    cy: 231.776,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.02,
    cy: 279.397,
    r: 7.031,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 346.527 276.206 C 343.226 271.14 337.912 265.85 330.733 260.483 L 329.232 262.489 C 343.183 272.919 349.681 282.888 347.531 290.56 C 346.333 294.833 342.537 298.303 336.248 300.875 C 329.943 303.453 321.482 304.996 311.1 305.461 C 308.894 305.56 306.63 305.609 304.309 305.609 C 283.995 305.609 259.501 301.848 234.459 294.829 C 231.175 293.908 227.932 292.945 224.728 291.94 L 224.728 294.564 C 227.712 295.491 230.73 296.383 233.782 297.241 C 259.044 304.321 283.774 308.114 304.322 308.114 C 306.674 308.114 308.975 308.064 311.212 307.964 C 333.444 306.968 347.199 301.027 349.943 291.236 C 351.216 286.695 350.067 281.638 346.527 276.206 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 311.1 307.465 C 308.895 307.563 306.631 307.613 304.309 307.613 C 283.997 307.613 259.5 303.852 234.458 296.833 C 231.175 295.912 227.931 294.949 224.728 293.944 L 224.728 296.568 C 227.711 297.495 230.729 298.387 233.782 299.245 C 259.044 306.325 283.773 310.118 304.321 310.118 C 306.674 310.118 308.976 310.068 311.213 309.967 C 313.915 309.847 316.489 309.654 318.934 309.389 C 319.366 308.509 319.781 307.62 320.179 306.723 C 317.338 307.072 314.312 307.319 311.1 307.465 Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.661,
    cy: 202.441,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 282.688 188.947 C 275.451 188.947 269.585 194.814 269.585 202.051 C 269.585 209.288 282.688 233.053 282.688 233.053 C 282.688 233.053 295.792 209.288 295.792 202.051 C 295.792 194.814 289.926 188.947 282.688 188.947 Z M 282.688 208.443 C 278.014 208.443 275.092 203.383 277.429 199.334 C 279.767 195.286 285.61 195.286 287.947 199.334 C 288.48 200.258 288.761 201.305 288.761 202.371 C 288.761 205.724 286.042 208.443 282.688 208.443 L 282.688 208.443 Z",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.843,
    cy: 235.675,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244.871 222.181 C 237.634 222.181 231.767 228.048 231.767 235.285 C 231.767 242.522 244.871 266.287 244.871 266.287 C 244.871 266.287 257.975 242.522 257.975 235.285 C 257.975 228.048 252.108 222.181 244.871 222.181 Z M 244.871 241.677 C 240.196 241.677 237.275 236.616 239.612 232.568 C 241.949 228.52 247.793 228.52 250.13 232.568 C 250.663 233.491 250.943 234.538 250.943 235.604 C 250.943 238.958 248.225 241.677 244.871 241.677 L 244.871 241.677 Z",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.843,
    cy: 176.657,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244.871 163.162 C 237.634 163.162 231.767 169.029 231.767 176.266 C 231.767 183.503 244.871 207.268 244.871 207.268 C 244.871 207.268 257.975 183.503 257.975 176.266 C 257.975 169.029 252.108 163.162 244.871 163.162 Z M 244.871 182.659 C 240.196 182.659 237.275 177.598 239.612 173.55 C 241.949 169.501 247.793 169.501 250.13 173.55 C 250.663 174.473 250.943 175.52 250.943 176.586 C 250.943 179.94 248.225 182.659 244.871 182.659 L 244.871 182.659 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.153,
    cy: 247.707,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 306.181 234.214 C 298.944 234.214 293.077 240.08 293.077 247.318 C 293.077 254.555 306.181 278.32 306.181 278.32 C 306.181 278.32 319.285 254.555 319.285 247.318 C 319.285 240.08 313.418 234.214 306.181 234.214 Z M 306.181 253.71 C 301.507 253.71 298.585 248.649 300.922 244.601 C 303.26 240.552 309.103 240.552 311.44 244.601 C 311.973 245.524 312.254 246.571 312.254 247.637 C 312.254 250.991 309.535 253.71 306.181 253.71 L 306.181 253.71 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.117,
    cy: 227.08,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188.145 213.586 C 180.907 213.586 175.041 219.453 175.041 226.69 C 175.041 233.927 188.145 257.692 188.145 257.692 C 188.145 257.692 201.248 233.927 201.248 226.69 C 201.248 219.453 195.382 213.586 188.145 213.586 Z M 188.145 233.082 C 183.47 233.082 180.548 228.021 182.886 223.973 C 185.223 219.925 191.066 219.925 193.404 223.973 C 193.937 224.896 194.217 225.943 194.217 227.009 C 194.217 230.363 191.498 233.082 188.145 233.082 L 188.145 233.082 Z",
    fill: "#ccc",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.555,
    cy: 276.93,
    r: 9.168,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 191.583 263.436 C 184.345 263.436 178.479 269.303 178.479 276.54 C 178.479 283.777 191.583 307.542 191.583 307.542 C 191.583 307.542 204.686 283.777 204.686 276.54 C 204.686 269.303 198.82 263.436 191.583 263.436 Z M 191.583 282.932 C 186.908 282.932 183.986 277.872 186.323 273.824 C 188.661 269.775 194.504 269.775 196.842 273.824 C 197.374 274.747 197.655 275.794 197.655 276.86 C 197.655 280.214 194.936 282.932 191.583 282.932 L 191.583 282.932 Z",
    style: {
      fill: "rgb(229, 26, 148)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandHero);
export default __webpack_public_path__ + "static/media/broadbandHero.d954bf1cddf82f99ec879508b564d2c3.svg";
export { ForwardRef as ReactComponent };